require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./vice-prsidence-finances-0-3-3.json") })
        }
      }, "path---vice-prsidence-finances-0-3-3");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---vice-prsidence-finances-0-3-3!./.cache/json/vice-prsidence-finances-0-3-3.json
// module id = 602
// module chunks = 231608221292675